/**
 * @desc 根据ShopKey查询站点店铺，状态非必填
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LabelInfoResponseDto>>;
export function request(body: defs.basics.LabelInfoQueryDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/labelInfo/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
